<div class="model-card">
    <div class="model-name">
        <h3>{{model.name}}</h3>
        <div>
            <div [ngSwitch]="model.type" class="d-inline-block">
                <span *ngSwitchCase="1"><mat-icon class="access-color-blue">bookmark</mat-icon> Demo access</span>
                <span *ngSwitchCase="2"><mat-icon class="access-color-green">bookmark</mat-icon> Live access</span>
                <span *ngSwitchCase="3"><mat-icon class="access-color-yellow">bookmark</mat-icon> Customized Model</span>
                <span *ngSwitchDefault><mat-icon>bookmark</mat-icon> Missing model type</span>
            </div>
            <div *ngIf="superAdmin" class="d-inline-block ms-2"> | {{model.access}}</div>
        </div>
    </div>
    <div class="model-stats">
        <span *ngIf="model.region && model.region.name"><mat-icon>location_on</mat-icon> {{model.region.name}}</span>
        <span *ngIf="model.universe && model.universe.name"><mat-icon>public</mat-icon> {{model.universe.name}}</span>
        <span *ngIf="model.companies"><mat-icon>business_center</mat-icon> {{model.companies}} companies</span>
        <span *ngIf="model.rebalancing && model.rebalancing.name"><mat-icon>calculate</mat-icon> {{model.rebalancing.name}}</span>
        <span *ngIf="model.currency && model.currency.name"><mat-icon>local_atm</mat-icon> {{model.currency.name}}</span>
    </div>
    <div class="model-action"><button type="button" mat-stroked-button class="rounded-pill border-primary" color="primary" [routerLink]="['model', model.id]">Show Overview</button></div>
</div>
